import {
  AutocompleteArrayInput,
  Datagrid,
  DateField,
  Filter,
  FunctionField,
  List,
  ReferenceArrayInput,
  ReferenceField,
  ReferenceInput,
  SelectArrayInput,
  SelectInput,
  TextField,
  TextInput,
  usePermissions,
  useTranslate,
} from "react-admin";
import { Permission, StarRatingField } from '../../components';
import { PERMISSIONS } from '../../constants';
import { useLocation } from 'react-router-dom';
import { BetweenDatesInput } from "../../components/BetweenDatesInput";
import { EmojiRating } from "../../components/EmojiArrayInput";
import dayjs from "dayjs";
import { filterToQuery, formatAttendantLabel } from "../../utils";

const scoreChoices = Array.from({ length: 5 }, (_, i) => ({ id: i + 1, name:`${EmojiRating[i]} (${i + 1})` }));

const RatingFilter = ({ ...props }) => {
  const translate = useTranslate();
  const { permissions } = usePermissions();

  return (
    <Filter {...props}>
      <BetweenDatesInput alwaysOn />
      <TextInput label="Buscar nos comentários" source="search" sx={{ minWidth: 220 }} alwaysOn />
      {Permission({
        permission: PERMISSIONS.LIST_ATTENDANT,
        children: (
          <ReferenceArrayInput
            reference="attendants"
            source="attendantIds"
            sort={{ field: "name", order: "ASC" }}
            perPage={null}
            alwaysOn
          >
            <SelectArrayInput
              optionText={record => formatAttendantLabel(record)}
              label="Frentistas"
              sx={{ minWidth: 220 }}
            />
          </ReferenceArrayInput>
        )
      })
      }
      <AutocompleteArrayInput style={{ minWidth: 220 }} choices={scoreChoices} source="attendantRating" label="Avaliação do Frentista" alwaysOn />
      {
        Permission({
          permission: PERMISSIONS.LIST_STATION,
          children: (
            <ReferenceArrayInput
              reference="stations"
              source="stationIds"
              sort={{ field: "name", order: "ASC" }}
              perPage={null}
              alwaysOn
            >
              <AutocompleteArrayInput
                label="Postos"
                optionText="name"
                filterToQuery={filterToQuery}
                sx={{ minWidth: 220, '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': { minWidth: 50 } }}
                noOptionsText={translate('ra.input.autocomplete.no_options_text')}
              />
            </ReferenceArrayInput>
          )
        })
      }
      <AutocompleteArrayInput style={{ minWidth: 220 }} choices={scoreChoices} source="stationRating" label="Avaliação do Posto" alwaysOn />
      <SelectInput
        source="hasComment"
        label="Comentários"
        choices={[
          { id: 'true', name: 'Com comentário' },
          { id: 'false', name: 'Sem comentário' },
        ]}
        alwaysOn
        emptyText="Todos"
      />
      {permissions && permissions.includes(PERMISSIONS.ADMIN) &&
        <ReferenceInput source="chainId" reference="chains" sort={{ field: 'name', order: 'ASC' }} perPage={null} alwaysOn>
          <SelectInput resettable label="Rede" optionText="name" />
        </ReferenceInput>}
    </Filter>
  )
}

export const RatingDatagrid: React.FC<{ showCustomerColumn?: boolean }> = ({ showCustomerColumn = true }) => (
  <Datagrid bulkActionButtons={false} rowClick="show">
    {
      showCustomerColumn &&
      <ReferenceField label="Cliente" reference="customers" source="customerId" link='show'>
        <TextField source="name" />
      </ReferenceField>
    }
    <StarRatingField source="attendantRating" label="Avaliação do frentista" />
    <StarRatingField source="stationRating" label="Avaliação do Posto" />
    <DateField source='createdAt' label='Data' showTime locales="pt-BR" />
    {
      Permission({
        permission: PERMISSIONS.LIST_FILLINS,
        children: (
          <ReferenceField label="Abastecimento" source="fillinId" reference="fillins" link='show' sortable={false}>
            <FunctionField render={() => 'Abastecimento'} />
          </ReferenceField>
        )
      })
    }
    <TextField source="comment" label="Comentário" />
  </Datagrid>
);

const RatingList = ({ permissions, ...props }) => {
  const { state: params } = useLocation();
  const redirectFilter = params?.filter ?? {};

  return (
    <List
      {...props}
      exporter={false}
      title="Avaliações"
      sort={{ field: 'createdAt', order: 'DESC' }}
      filters={<RatingFilter />}
      actions={false}
      filterDefaultValues={{
        from: dayjs().startOf('day').subtract(1, "month").toISOString(),
        to: dayjs().endOf('day').toISOString()
      }}
      perPage={25}
      filter={{ ...redirectFilter }}
    >
      <RatingDatagrid />
    </List>
  )

}

export default RatingList;
